
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appsumo/signup",
      function () {
        return require("private-next-pages/appsumo/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appsumo/signup"])
      });
    }
  